module.exports = __webpack_public_path__ + "img/empty.3f231424.webp";